var PacketArticle = /** @class */ (function () {
    function PacketArticle(props) {
        this.prices = [];
        // console.log('Packet - constructor - props: ', props)
        Object.assign(this, props);
    }
    return PacketArticle;
}());
export default PacketArticle;



//////////////////
// WEBPACK FOOTER
// ./src/modules/PacketArticles/Model.ts
// module id = 717
// module chunks = 0